<div class="mt-2">
  <div class="row">
    <div class="col-md-8 w-100 mt-3">
      <h4 class="title"><i class="fa fa-users"></i> {{title | translate}}</h4>
    </div>
    <div class="col-md-4 mt-3 content-position-end">
      <div ngbDropdown class="d-inline-block custom-button">
        <button class="btn btn-outline-success custom-button font-weight-bold" id="dropdownForm1" ngbDropdownToggle>
          <i class="fa fa-plus" aria-hidden="true"></i> {{ "BUTTON.MORE-ACTIONS" | translate }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownForm1">
          <a ngbDropdownItem class="cursor-hover"
             (click)="loadRequiredDataAndOpenModal(OPTION_ADD)">
            <i class="fa fa-user"></i> {{ "BUTTON.ADD-A-PERSON" | translate }}
          </a>
          <a ngbDropdownItem class="cursor-hover"
             (click)="openModalAddBatch()">
            <i class="fa fa-users"></i> {{ "BUTTON.ADD-PERSONS-IN-BATCH" | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bg-white-radius">
  <div class="row">
    <div class="col-md-2" *ngIf="hasRole(ROLE_SUPERADMIN)">
      <label class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-university" aria-hidden="true"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="partnerSelected"
                (ngModelChange)="reloadPeople0()">
          <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
      <label class="font-weight-bold">
        {{ "LABEL.ENTERPRISE" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="enterpriseSelected"
                (ngModelChange)="reloadPeople1()">
          <option *ngFor="let enterprise of enterprises" [ngValue]="enterprise">{{enterprise.name | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2" *ngIf="hasRole(ROLE_SUPERADMIN)
    || hasRole(ROLE_PARTNER) || hasRole(ROLE_ADMIN) || hasRole(ROLE_ADMIN_NOTCER)">
      <label class="font-weight-bold">{{ "LABEL.PARTICIPANT-TYPE" | translate }}:</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-user-tie"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="participantTypeSelected"
                (ngModelChange)="reloadPeople1()">
          <option *ngFor="let participantType of participantTypes"
                  [ngValue]="participantType">{{'SELECT.OPTIONS.' + participantType.description | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2" *ngIf="!isInvited">
      <label class="font-weight-bold">{{ "LABEL.ROLE" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend icon-width">
          <div class="input-group-text"><i class="fas fa-user-tag"></i></div>
        </div>
        <select class="form-control"
                [(ngModel)]="roleSelected"
                (ngModelChange)="reloadPeople1()">
          <option *ngFor="let rol of roles" [ngValue]="rol">{{rol.nameView.toUpperCase() | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-3">
      <label class="font-weight-bold">{{ "LABEL.DNI-NAMES" | translate }}:</label>
      <div class="input-group">
        <div class="input-group-prepend icon-width">
          <div class="input-group-text"><i class="fas fa-keyboard"></i></div>
        </div>
        <input type="text"
               id="searchInput"
               class="form-control"
               placeholder="{{ 'MESSAGE.ENTER-TO-SEARCH' | translate }}"
               [(ngModel)]="term2Search"
               (keyup.enter)="search()">

      </div>
    </div>
    <div class="col-md-1 mt-2">
      <button type="button"
              class="btn btn-outline-success cm-top custom-button"
              [disabled]="term2Search === undefined"
              (click)="search()"><i class="fas fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
      </button>

    </div>
  </div>
  <div class="table-responsive mt-2 mb-2 custom-table-height">
    <table class="table-sm table-bordered">
      <thead class="custom-font-size-table-header">
      <tr>
        <th scope="col" title="Identificador"></th>
        <th scope="col" *ngIf="hasRole(ROLE_SUPERADMIN)" title="{{ 'TABLE.HEADER.OWNER' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DOCUMENT-TYPE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DOCUMENT-NUMBER' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.COMPLETE-NAME' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.JOB' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.PART-TYPE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ROLE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.MAIL' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let person of people" class="custom-font-size-table-body">
        <td title="Identificador"><b>{{person.id}}</b></td>
        <td title="{{ 'TABLE.HEADER.OWNER' | translate }}"
            *ngIf="hasRole(ROLE_SUPERADMIN)">{{person._more.enterpriseTradeName}}</td>
        <td title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}">{{person._more.enterpriseTradeNameView}}</td>
        <td title="{{ 'TABLE.HEADER.DOCUMENT-TYPE' | translate }}">
          {{person.documentType | descriptionDocumentType}}
        </td>
        <td title="{{ 'TABLE.HEADER.DOCUMENT-NUMBER' | translate }}">{{person.documentNumber}}</td>
        <td title="{{ 'TABLE.HEADER.COMPLETE-NAME' | translate }}">{{person.fullname | translate}}</td>
        <td title="{{ 'TABLE.HEADER.JOB' | translate }}">
          {{person._more.jobDescription }}
        </td>
        <td title="{{ 'TABLE.HEADER.PART-TYPE' | translate }}">
          {{person._more.participantType | descriptionParticipantType}}
        </td>
        <td title="{{ 'TABLE.HEADER.ROLE' | translate }}">
          {{person._more.rolesNameView ? person._more.rolesNameView : '-'}}</td>
        <td title="{{ 'TABLE.HEADER.MAIL' | translate }}">{{person.email}}</td>
        <td title="{{ 'TABLE.HEADER.DATE' | translate }}">{{person.createAt | dateformat}}</td>
        <td title="{{ 'TABLE.HEADER.STATE' | translate }}">
        <span
          class="{{!person.active? 'badge badge-danger':''}}">{{person.active ? ("LABEL.ACTIVE" | translate) : ('LABEL.INACTIVE' | translate)}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.ACTION' | translate }}">
          <div class="dropdown">
            <button type="button" class="btn btn-default " id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item cursor-hover"
                      *ngIf="hasAuthority('own:person:add:workflow')"
                      (click)="openModalAssignWorkflow(person)">
                <i class="fa fa-code-branch"></i> {{ "BUTTON.ASSIGN-FLOWS" | translate }}
              </button>
              <button class="dropdown-item cursor-hover"
                      *ngIf="hasAuthority('own:person:edit')"
                      (click)="loadRequiredDataAndOpenModal(OPTION_EDIT, person)">
                <i class="fa fa-pen"></i> {{ "BUTTON.EDIT" | translate }}
              </button>
              <button class="dropdown-item cursor-hover"
                      *ngIf="hasAuthority('own:person:edit:password')"
                      (click)="openModalResetPassword(person)">
                <i class="fa fa-redo"></i> {{ "BUTTON.RESET-CREDENTIALS" | translate }}
              </button>
              <button class="dropdown-item cursor-hover"
                      *ngIf="hasAuthority('own:person:edit:authority') && hasAuthority('own:authority:get:person')"
                      (click)="openModalAssignMoreAuthorities(person)">
                <i class="fa fa-plus"></i> {{ "BUTTON.ASSIGN-MORE-PERMISSIONS" | translate }}
              </button>
              <button class="dropdown-item cursor-hover"
                      *ngIf="hasAuthority('own:person:delete')"
                      (click)="delete(person)">
                <i class="fa fa-trash"></i> {{ "BUTTON.DELETE" | translate }}
              </button>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <nav class="Page navigation pagination-custom">
    <div class="row">
      <div class="col-md-8 mt-1">
        <div class="justify-content-row">
          <span class="mr-1 font-weight-normal">Mostrar </span>
          <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                  (ngModelChange)="loadPeople(enumPage.First)">
            <option *ngFor="let page of pageNumbers" [value]="page.value"
                    class="font-weight-bold">{{page.value}}</option>
          </select>
          <span class="font-weight-normal"> registros.</span>
        </div>
        <div class="page-total-entries">
          {{ "LABEL.TOTAL-RECORDS" | translate }}
          : {{people.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
        </div>
      </div>
      <div class="col-md-4">
        <ul class="pagination justify-content-end text-center">
          <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
            <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadPeople(enumPage.First)"
               tabindex="-1" aria-disabled="true">
              <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
              {{ "BUTTON.FIRST" | translate }}
            </a>
          </li>
          <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
            <a class="left" (click)="loadPeople(enumPage.Previous)">
              <i class="fa fa-angle-left" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="right" (click)="loadPeople(enumPage.Next)"><i
              class="fa fa-angle-right" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="loadPeople(enumPage.Last)">
            <a class="next">
              {{ "BUTTON.LAST" | translate }}
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<app-loading *ngIf="loading"></app-loading>
